import makeRequest from './utils/makeRequest';

const makeRequestWithMethod = async (url, options, method) => {
    const {
        headers,
        abortControllerCallback,
        body,
        queryParams,
        timeout,
        credentials,
    } = options ?? {};

    return makeRequest(url, {
        method,
        headers,
        abortControllerCallback,
        body,
        queryParams,
        timeout,
        credentials,
    });
};

export const get = async (url, options) => {
    return makeRequestWithMethod(url, options, 'GET');
};

export const post = async (url, options) => {
    return makeRequestWithMethod(url, options, 'POST');
};

export const patch = async (url, options) => {
    return makeRequestWithMethod(url, options, 'PATCH');
};

export const deleteRequest = async (url, options) => {
    return makeRequestWithMethod(url, options, 'DELETE');
};

export const put = async (url, options) => {
    return makeRequestWithMethod(url, options, 'PUT');
};

export const upload = async () => {};
